import React, { useMemo } from 'react';
import { Button, List, Typography } from 'antd';
import { CheckCircleTwoTone } from '@ant-design/icons'; 
import { getString } from '@nackle/intl-tools';
import { STATUS } from '../../services/CourseService/CourseService';
import FileIcon from '../FileIcon/FileIcon';
import './styles.less';

const WidgetCourseListItem = ( { learningObject, courseStartCallback, enabled } ) => {
   
    const buttonText = useMemo( () => {
        if ( learningObject.status === STATUS.COMPLETED ) {
            return getString( 'button.complete.label' );
        }
        
        if ( learningObject.status === STATUS.IN_PROGRESS ) {
            return getString( 'button.resume.label' );
        }
        
        return getString( 'button.start.label' );
    }, [ learningObject ] );

    const handleCourseClick = () => {
        courseStartCallback( learningObject );
    };
    
    return (
        <List.Item
            className="widget-course-list-item"
            key={ learningObject.key }
            actions={ [
                learningObject.status === STATUS.COMPLETED ? 
                    <CheckCircleTwoTone twoToneColor="#52c41a"/> : null,
                    
                <Button
                    key={ `launch-course-button-${ learningObject.id }` } 
                    disabled={ !enabled }
                    onClick={ () => handleCourseClick() }
                >
                    { buttonText }
                </Button>
            ] }    
        >   
            <FileIcon mimeType={ learningObject.content.mimetype } />    

            <List.Item.Meta
                title={
                    <Typography.Text ellipsis={ true }>
                        { learningObject.name }
                    </Typography.Text>
                }

                description={ 
                    <Typography.Paragraph 
                        type="secondary"
                        ellipsis={ { rows: 2 } }
                    >
                        <span dangerouslySetInnerHTML={ { __html: learningObject.description } } />
                    </Typography.Paragraph>
                }
            />
        </List.Item>
    );
};

export default WidgetCourseListItem;
